import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  applyFilters(e) {
    e.preventDefault();

    if($(".filters-form").valid()) {
      $('.internet-usages-datatable').DataTable().ajax.reload()
    }
  }
}
